const MoreSelectedBadge = ({ items }) => {
  const style = {
    marginLeft: "auto",
    background: "#3776b7", // #d4eefa
    borderRadius: "4px",
    color: "#fff",
    fontFamily: "Open Sans",
    fontSize: "12px",
    fontWeight: 600,
    padding: "5px 8px", // 3px
    order: 99
  };

  const title  = items.join(", ");
  const length = items.length;
  const label  = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

export default MoreSelectedBadge;
